import Logo from "@assets/img/logo.png";
import LogoIcon from "@assets/img/logo.png";
import LogoWhite from "@assets/img/logo-white.png";
import NoImageFound from "@assets/img/No_Image_Available.jpg";
import TransparentLoader from "@assets/img/loading_transparent.gif";
import colors from "../../colors";
import RetailerLogo from "@assets/img/HEPLLogo.png"

export const APP_NAME = "Pre Order Management";
export const APP_LOGO = Logo;
export const APP_LOGO_ICON = LogoIcon;
export const APP_LOGO_WHITE = LogoWhite;
export const TRANSPARENT_LOADER = TransparentLoader;
export const RECAPTCHA_SITE_KEY = "6Lc6GIYrAAAAANus_t-2SEb3IJx0ebYzwpDjcM7B";
export const RETAILER_LOGO = RetailerLogo

export const CURRENCY_SIGN = "Rs.";
export const INTL_NUMBER_FORMAT = "en-IN"; // en-US
export const INITIAL_LOGIN_METHOD = "mobile"; //email, mobile
export const DISABLE_MOBILE_REGISTER = false;
export const SHOW_REFERAL_CODE_INPUT = true;
export const HOME_LAYOUT_SIZE = 8;
export const LOCATIONS = {
  label1: "State",
  label2: "District",
  label3: "Area",
  label4: "Area-in",
};

export const ADMIN = "666816f777d920ef32e6b866";
export const ND = "6668171977d920ef32e6b8c1";
export const RETAILER = "6668174777d920ef32e6b9a3";

export const locationLevel = {
  level_1: "State",
  level_2: "District",
  level_3: "Area",
  level_4: "Area-in",
}; // for Nepal

export const KHALTI_SIE_KEY =
  process.env.NODE_ENV === "production"
    ? "live_public_key_2eff9fc328b74149bf5d957c770f74c7"
    : "test_public_key_0a22de673ca44239a009231d27dd34bf";
export const MIN_CART_AMOUNT = 1;
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const MULTI_VENDOR = false;
export const BENEFIT_TYPE = "both";

export const ALLOW_TRACKABLE = true;
export const ALLOW_MULTI_VARIANT = true;
export const ALLOW_COMPARE = false;
export const SHOW_QUESTION = true;
export const DEMO_RIBBON = false;

export const IS_COMING_SOON = false;
export const RELEASE_DATE = "2023/6/17";
export const PHONE_NO = "9801667788";
export const COUNTRY_CODE = "+977";

export const LOAD_MORE_BUTTON = true;
export const DETAIL_TABS = false;
export const PUBLIC_BASE = "https://campaign.samsungplaza.com.np/";
export const IMAGE_BASE = process.env.IMAGE_BASE;
export const NoImage = NoImageFound;
export const PRIMARY_COLOR = colors.primary;
export const SECONDARY_COLOR = colors.secondary;

export const IGNORE_LAYOUT = [
  "/admin/home-page-groups/add",
  "/admin/home-page-groups/edit/:id",
];

export const SLIDER_EXTRA_SETTINGS = `{
  "adaptiveHeight": true,
         "responsive":
       [
       {
                 "breakpoint": 1280,
                 "settings": {
                     "arrows": false,
                     "slidesToShow": 6,
                     "slidesToScroll": 6
                 }
             },
        {
                 "breakpoint": 1024,
                 "settings": {
                     "arrows": false,
                     "slidesToShow": 4,
                     "slidesToScroll": 4
                 }
             },

              {
                 "breakpoint": 768,
                 "settings": {
                     "arrows": false,
                     "slidesToShow": 3,
                     "slidesToScroll": 3
                 }
             },
             {
                 "breakpoint": 480,
                 "settings": {
                     "arrows": false,
                     "slidesToShow": 2,
                     "slidesToScroll": 2,
                      "dots": false
                 }
             }
         ]
     }`;

export const ADMIN_MENU_SCROLLBAR_MAXWIDTH = 256;
export const ADMIN_MENU_SCROLLBAR_MINWIDTH = 73;
export const DOMAIN = "https://campaign.samsungplaza.com.np/";
